import React from 'react';
import PropTypes from 'prop-types';
import { renderImage } from 'helpers/ImageHelper';

// This would replace TileImage
// TODO: implement hover logic, probably in a separate component such as <HoverImage>?
// TODO: implement VideoHero logic, probably in a separate component such as <Video>?
const Image = ({ breakpoint, imageType, src, children, theme }) => (
  <div>
    {renderImage({
      breakpoint,
      imageType,
      src,
      className: theme.image,
    })}
    {children}
  </div>
);

Image.defaultProps = {
  children: [],
  theme: {},
};

Image.propTypes = {
  breakpoint: PropTypes.string.isRequired,
  imageType: PropTypes.string.isRequired,
  src: PropTypes.string.isRequired,
  children: PropTypes.arrayOf(PropTypes.element),
  theme: PropTypes.shape({}),
};

export default Image;
